interface EnvironmentConfig {
  BASE_API_URL: string
}

export const ENV = import.meta.env.MODE || "development"

const configs: Record<string, EnvironmentConfig> = {
  development: {
    BASE_API_URL: "https://gated.dev.inflowservice.com",
  },
  staging: {
    BASE_API_URL: "https://gated.staging.inflowservice.com",
  },
  production: {
    BASE_API_URL: "https://gated.prod.inflowservice.com",
  },
}

const config: EnvironmentConfig = configs[ENV] || configs.development

export const BASE_API_URL = config.BASE_API_URL
